// Constants
export const CART_LOADING = 'CART_LOADING';
export const CARTS_FULFILLED = 'CARTS_FULFILLED';
export const CARTS_COUNT_FULFILLED = 'CARTS_COUNT_FULFILLED';
export const CHECKOUT_LOADING = 'CHECKOUT_LOADING';
